/* eslint-disable max-classes-per-file */
class SalesTaxType {
  constructor(fullName, label) {
    this.fullName = fullName;
    this.label = label;
  }
}

export const VAT = new SalesTaxType('Value Added Tax', 'VAT');

export const GST = new SalesTaxType('Goods and Services Tax', 'GST');

const defaultSalesTaxType = VAT;

const countryCodeToSalesTaxType = {
  SG: GST,
};

const countryCodeToSalesTaxRate = {
  AT: '20',
  BE: '21',
  BG: '20',
  HR: '25',
  CL: '19',
  CY: '19',
  CZ: '21',
  DK: '25',
  EE: '20',
  FI: '24',
  FR: '20',
  DE: '19',
  EL: '24',
  HU: '27',
  IE: '23',
  IT: '22',
  LV: '21',
  LT: '21',
  LU: '17',
  MT: '18',
  NL: '21',
  PL: '23',
  PT: '23',
  RO: '19',
  RU: '20',
  SK: '20',
  SI: '22',
  ES: '21',
  SE: '25',
  GB: '20',
  SG: '7',
};

const isoCountryCodeToTaxCountryCode = {
  GR: 'EL',
};

const isoToTaxCountryCode = (countryCode) =>
  isoCountryCodeToTaxCountryCode[countryCode] || countryCode;

const reverseChargeInapplicableCountryCodes = ['MT', 'RU'];

const isReverseChargeInapplicable = (countryCode) =>
  reverseChargeInapplicableCountryCodes.includes(countryCode);

const salesTaxPrefixExempt = ['CL', 'RU', 'SG'];

const hasSalesTaxPrefix = (countryCode) => !salesTaxPrefixExempt.includes(countryCode);

export class SalesTax {
  // FIXME: Please fix this. You may refer to CFE-266 for more details.
  // eslint-disable-next-line func-params-args/func-params
  constructor(type, rate, reverseChargeInapplicable, numberPrefix) {
    this.type = type;
    this.rate = rate;
    this.reverseChargeInapplicable = reverseChargeInapplicable;
    this.numberPrefix = numberPrefix;
  }
}

export class SalesTaxRepository {
  static byCountryCode(countryCode) {
    const taxCountryCode = isoToTaxCountryCode(countryCode);

    if (countryCodeToSalesTaxRate[taxCountryCode] === undefined) {
      return null;
    }

    const rate = countryCodeToSalesTaxRate[taxCountryCode];
    const salesTaxType = countryCodeToSalesTaxType[taxCountryCode] || defaultSalesTaxType;
    const reverseChargeInapplicable = isReverseChargeInapplicable(taxCountryCode);
    const prefix = hasSalesTaxPrefix(taxCountryCode) ? taxCountryCode : '';

    return new SalesTax(salesTaxType, rate, reverseChargeInapplicable, prefix);
  }
}

/**
 * Some sales tax types have prefixes before their numbers. We split
 * the stored VAT number into its (prefix,number) pair, as the
 * prefix will be shown as a label on the input field later.
 */
export function detachPrefix(vatNumber, countryCode) {
  if (!vatNumber) {
    return null;
  }

  const salesTax = SalesTaxRepository.byCountryCode(countryCode);

  if (!salesTax) {
    return vatNumber;
  }

  return vatNumber.slice(salesTax.numberPrefix.length);
}

export function vatAppliesToCountry(isoContryCode) {
  return Object.prototype.hasOwnProperty.call(countryCodeToSalesTaxRate, isoContryCode);
}
